import { render, staticRenderFns } from "./SolicitacaoStatus.vue?vue&type=template&id=45ffc4ac"
import script from "./SolicitacaoStatus.vue?vue&type=script&lang=js"
export * from "./SolicitacaoStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports